<template>
  <div
    class="calico-status-card"
    @click="selectCard"
  >
    <div
      class="container"
      :class="{
        active: value === modelValue,
        disabled,
      }"
    >
      <div
        class="content"
        :class="{ disabled }"
      >
        <span :class="`badge-${badgeColor}`">{{ badgeLabel }}</span>
        <h3 class="heading--xsmall">
          {{ title }}
        </h3>
        <p class="body--medium">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>
  
  <script>
  
  export default {
    name: "CalicoStatusCard",
    props: {
      value: {
        type: [String, Number],
        required: true,
      },
      modelValue: {
        type: [String, Number],
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: "",
      },
      description: {
        type: String,
        default: "",
      },
      badgeLabel: {
        type: String,
        default: "",
      },
      badgeColor: {
        type: String,
        default: "green",
      },
    },
    methods: {
      selectCard() {
        if (!this.disabled && this.value !== this.modelValue) {
          this.$emit("update:modelValue", this.value);
        }
      },
    },
  };
  </script>
  
  <style lang="scss">
  .calico-status-card {
    width: fit-content;
    height: fit-content;
  
    .container {
      @include inline-space($space-small);
      @include inset-space($space-medium);
      border: 1px solid $color-neutral-light;
      border-radius: $radius-large;
      color: $color-black;
      cursor: pointer;
  
      &:hover:not(.disabled) {
        background-color: $color-neutral-lightest;
        border-color: $color-neutral-light;
      }
  
      .content {
        @include stack-space($space-small);
        h3, p {
          margin: 0;
        }
      }
    }
  
    .active {
      background-color: $color-lapis-lightest;
      border-color: $color-neutral-light;
    }
  
    .disabled {
      background-color: $color-neutral-light;
      border-color: $color-neutral-light;
      color: $color-neutral-dark;
      cursor: not-allowed;
    }
  }
  </style>
  